"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ScrollTop() {
  const pathname = usePathname();

  useEffect(() => {
    // Always scroll to the top on route change
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}